// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var OrderLinkType;
(function (OrderLinkType) {
    OrderLinkType[OrderLinkType["ORDER_LINK_NONE"] = -1] = "ORDER_LINK_NONE";
    // use to bound OCO orders:
    OrderLinkType[OrderLinkType["ORDER_LINK_CANCEL"] = 0] = "ORDER_LINK_CANCEL";
    // use to build execution chain:
    OrderLinkType[OrderLinkType["ORDER_LINK_EXECUTE_AFTER"] = 1] = "ORDER_LINK_EXECUTE_AFTER";
})(OrderLinkType || (OrderLinkType = {}));
